import { ADMIN_DETAIL , ADMIN_TOKEN, OTHER_USER_DATA, OTHER_USER_DATA_CHAT, SIDE_LIST_DATA} from "../types";

const INITIAL_STATE = {
    admin_data: null,
    admin_token:null,
    sideDeatils: [],
    activeChatDetails:null,
    activeChatDetailchat:null,
};

export default (state = INITIAL_STATE, action) => {
    const { type, payload } = action;
    switch (type) {
        case ADMIN_DETAIL:
            return {
                ...state,
                admin_data: payload,
            };
        case ADMIN_TOKEN:
            return {
                ...state,
                admin_token: payload,
            };
            case SIDE_LIST_DATA:
                return {
                  ...state,
                  sideDeatils: payload,
                };
            case OTHER_USER_DATA:
                return {
                  ...state,
                  activeChatDetails: payload,
                };
            case OTHER_USER_DATA_CHAT:
                return {
                  ...state,
                  activeChatDetailchat: payload,
                };

        default:
            return state;
    }
};
